import { useNavigate, useParams } from "react-router-dom";
import backLogo from "../../../../assets/business/images/Button-icon.svg";
import thankYouImage from "../../../../assets/business/images/thank-you-img.png";

function AccountRedirectionPage() {
  const navigate = useNavigate();
  const { status } = useParams(); // "success" or "failed"

  const handleNavigate = () => {
    navigate("/business/account-setting");
  };

  // Handle dynamic text
  const heading = status === "failed" ? "Oops!" : "Thank you!";
  const message =
    status === "failed"
      ? "Something went wrong while submitting your bank account details. Please try again or contact support."
      : "Thank you! Your bank account details have been submitted successfully. Stripe is reviewing your information, and you’ll receive an update via email/SMS once the verification is complete.";

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="container section-section">
            <div className="thank-you-wrapper text-center">
              <div className="logo">
                <img src={thankYouImage} alt="Logo" />
              </div>
              <h4 className="h2-headline">{heading}</h4>
              <p className="subtitle-1 text">{message}</p>

              <div className="col-md-12 text-center mt-5">
                <button
                  type="submit"
                  className="btn btn-light-purple px-5"
                  onClick={handleNavigate}
                >
                  <span className="px-3">Home</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountRedirectionPage;
